import { Ref } from "@vue/composition-api";
import { filter as Rfilter } from "ramda";
import { v4 as uuidv4 } from "uuid";
import { ClientAndTasks } from "@/store/modules/workOrderTasks";

export const filteredWorkOrderTasks = (
  filter: Ref<string>,
  tasksByClient: Ref<any[]>,
) => {
  if (filter.value != "") {
    return Rfilter((item: any) => {
      let clientResult = item.client.search(new RegExp(filter.value, "i"));
      return clientResult > -1;
    }, tasksByClient.value);
  } else {
    return tasksByClient.value;
  }
};

export const localizeTask = (item: ClientAndTasks) => {
  return {
    visible: false,
    browserId: `cl-${uuidv4()}`,
    countOfTasks: item.tasks.length,
    ...item,
  };
};
